import { Skeleton } from "antd";
import { useFetchLocalStorage } from "../../lib/useFetchLocalStorage";
import useUser from "../../lib/useUser";
import AllStaff from "../../components/staff/AllStaff";
import SectionTitle from "../../components/shared/SectionTitle";
import * as ROUTES from "../../constants/routes";

function Staff() {
  useFetchLocalStorage();
  const { status, user } = useUser({ redirectTo: "/login" });

  if (status === "loading" || !user) return <Skeleton active />;

  return (
    <>
      <SectionTitle
        title="All Staff"
        buttonTo={ROUTES.STAFF_ADD}
        buttonTitle="Add staff"
      />
      <AllStaff />
    </>
  );
}

export default Staff;
